import { Component } from '@angular/core';
import { Nav, IonicPage, NavController, AlertController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { MenuPage } from '../menu/menu';
import { HomePage } from '../home/home';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';

@IonicPage()
@Component({
  selector: 'page-portfolios',
  templateUrl: 'portfolios.html'
})
export class PortfoliosPage {
  pages: Array<{ title: string; component: any }>;
  portfolios: Array<{ title: string; background: string; contentCount: any }>;

  constructor(
    public navCtrl: NavController,
    public nav: Nav,
    private http: HttpClient,
    private alertCtrl: AlertController,
    private appConfig: AppConfigProvider
  ) {
    this.pages = [
      { title: 'Home', component: HomePage },
      { title: 'Portfolios', component: PortfoliosPage }
    ];
    // { title: 'Logout', component: LoginPage}

    this.portfolios = [];
    this.getPortfolio();
  }

  openPage(page) {
    this.navCtrl.push(page.component);
  }

  openLogin() {
    this.navCtrl.push(LoginPage);
  }

  openSlide(row) {
    if (row.contentCount == 0) {
      let alert = this.alertCtrl.create({
        title: 'Item Coming Soon',
        subTitle: 'Sorry, item will not be available until release.',
        buttons: ['Dismiss']
      });

      alert.present();
    } else {
      this.navCtrl.push(MenuPage, {
        portfolio_title: row.title,
        portfolio_id: row.id,
        header_img: row.background
      });
    }
  }

  getPortfolio() {
    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/portfolio/list', {
        token: 'token',
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          let data = res.portfolio;
          console.log(data);
          for (let pfolio of data) {
            let temp = {
              id: pfolio.portfolio_id,
              title: pfolio.title,
              background: pfolio.feature_image,
              contentCount: pfolio.total_subportfolio
            };
            this.portfolios.push(temp);
          }
        },
        err => {
          console.log('Error request' + JSON.stringify(err));
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/portfolios/portfolios.ts